<div *ngIf="error">
  {{ error }}
</div>
<div class="flex flex-row sm:flex-col justify-start gap-5">
  <div class="flex-grow-0 flex-shrink-0 basis-0">
    <ca-profile-image
      [file]="userForm.get('profileImage').value"
    ></ca-profile-image>
  </div>
  <div class="flex-grow flex-shrink basis-0">
    <form [formGroup]="userForm">
      <div class="input-group">
        <mat-form-field>
          <input
            matInput
            type="text"
            placeholder="First Name"
            formControlName="firstName"
          />
        </mat-form-field>
        <mat-form-field>
          <input
            matInput
            type="text"
            placeholder="Last Name"
            formControlName="lastName"
          />
        </mat-form-field>
      </div>
    </form>
    <form [formGroup]="roleForm" (submit)="onSubmit($event)">
      <mat-form-field class="input-wide">
        <input
          matInput
          type="text"
          autocomplete="off"
          autocapitalize="off"
          placeholder="ID"
          formControlName="externalId"
        />
        <mat-hint>{{ "invite.externalIdDescription" | translate }}</mat-hint>
      </mat-form-field>
      <ca-role-select
        [placeholder]="model === 'Tenant' ? 'Tenant Role' : 'Organisation Role'"
        formControlName="role"
        [options]="model === 'Tenant' ? TENANT_ROLES : ORGANISATION_ROLES"
      ></ca-role-select>
      <ng-container
        *ngIf="roleForm.get('role').value === CARER"
        formGroupName="qualifications"
      >
        <label id="customer-access-group"><h2>Customer Access</h2></label>
        <mat-radio-group
          aria-labelledby="customer-access-group"
          formControlName="accessAllCustomers"
        >
          <mat-radio-button class="qualifications-radio" [value]="true">
            <p>
              <strong>
                {{
                  "staff.accessAllCustomers" + roleForm.get("role").value
                    | translate
                }}</strong
              ><br />
              <span style="white-space: normal">
                {{
                  "staff.accessAllCustomersEnabled" + roleForm.get("role").value
                    | translate
                }}
              </span>
            </p>
          </mat-radio-button>
          <mat-radio-button class="qualifications-radio" [value]="false">
            <p>
              <strong>
                {{
                  "staff.limitedCustomers" + roleForm.get("role").value
                    | translate
                }}</strong
              ><br />
              <span style="white-space: normal">
                {{
                  "staff.accessAllCustomersDisabled" +
                    roleForm.get("role").value | translate
                }}
              </span>
            </p>
          </mat-radio-button>
        </mat-radio-group>
      </ng-container>
      <h2>{{ "staff.accountEnabled" | translate }}</h2>
      <mat-slide-toggle formControlName="enabled">{{
        "staff.accountEnabled" | translate
      }}</mat-slide-toggle>
      <p *ngIf="roleForm.get('enabled').value === false">
        {{
          "staff.accountDisabledWarning" + (model === "Tenant" ? ".tenant" : "")
            | translate
        }}
      </p>
      <div class="submit">
        <button
          [disabled]="loading || disabled"
          color="primary"
          mat-flat-button
        >
          {{ "save" | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
